import {
  TPaymentMethodMode,
  TPaymentMethodConfimationType,
} from '../../store/types';

export const paymentMethodModeList: TPaymentMethodMode[] = ['remote', 'custom', 'h2h'];

export const paymentMethodModeTitles: Record<TPaymentMethodMode, string> = {
  remote: 'Сторонний метод',
  custom: 'Свой метод',
  h2h: 'Свой flow через H2H',
};

export const paymentMethodConfirmationTypeList: TPaymentMethodConfimationType[] = ['receipt', 'hash'];

export const paymentMethodConfirmationTypeTitles: Record<TPaymentMethodConfimationType, string> = {
  receipt: 'Чек',
  hash: 'Хэш',
};
